import React, { useEffect } from "react";

export default function PaymentPage() {
useEffect(() => {
document.title = "Pricing • Backlink Banana";


const description =
  "Discover outreach-ready websites, SEO metrics, and LinkedIn prospects in minutes — without wasting hours on manual prospecting.";

let metaDesc = document.querySelector("meta[name='description']");

if (!metaDesc) {
  metaDesc = document.createElement("meta");
  metaDesc.setAttribute("name", "description");
  document.head.appendChild(metaDesc);
}

metaDesc.setAttribute("content", description);


}, []);

const PLANS = [
{
credits: 150,
amount: 9,
label: "Starter",
subtitle: "Perfect for freelancers and smaller campaigns",
},
{
credits: 500,
amount: 29,
label: "Growth",
subtitle: "Built for consistent outreach workflows",
popular: true,
},
{
credits: 1500,
amount: 79,
label: "Pro",
subtitle: "For agencies and high-volume prospecting",
},
];

return ( <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-24">

  {/* HERO */}
  <div className="max-w-4xl mx-auto text-center mb-20">

    <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
      Built for modern SEO prospecting
    </div>

    <h1 className="text-5xl sm:text-6xl font-bold tracking-tight text-gray-900 leading-tight mb-6">
      Stop Spending Hours
      <br />
      Prospecting Manually
    </h1>

    <p className="text-xl text-gray-600 leading-relaxed">
      Backlink Banana helps you discover outreach-ready websites,
      SEO metrics, and LinkedIn prospects in minutes —
      without spreadsheets, repetitive searches, or bloated SEO software.
    </p>

  </div>

  {/* PRICING */}
  <div className="grid lg:grid-cols-3 gap-8 mb-24">

    {PLANS.map(({ credits, amount, label, subtitle, popular }) => {

      const perCredit = (amount / credits).toFixed(2);

      return (
        <div
          key={credits}
          className={`relative rounded-3xl border bg-white p-8 transition-all duration-300 hover:shadow-2xl ${
            popular
              ? "border-blue-600 shadow-xl scale-[1.03]"
              : "border-gray-200"
          }`}
        >

          {popular && (
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg">
              Most Popular
            </div>
          )}

          <div className="mb-8">

            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              {label}
            </h3>

            <p className="text-gray-500 text-sm">
              {subtitle}
            </p>

          </div>

          <div className="mb-8">

            <div className="flex items-end gap-1">

              <span className="text-6xl font-extrabold text-gray-900">
                ${amount}
              </span>

            </div>

            <p className="text-gray-600 mt-3">
              {credits} Credits (1 Credit = 1 Website)
            </p>

            <p className="text-sm text-gray-500 mt-1">
              ~${perCredit} per prospect
            </p>

          </div>

          <div className="space-y-4">

            <div className="flex items-start gap-3">
              <div className="text-green-500 mt-1">✓</div>

              <p className="text-gray-700">
                Discover outreach-ready websites
              </p>
            </div>

            <div className="flex items-start gap-3">
              <div className="text-green-500 mt-1">✓</div>

              <p className="text-gray-700">
                DA, PA & Spam Score included
              </p>
            </div>

            <div className="flex items-start gap-3">
              <div className="text-green-500 mt-1">✓</div>

              <p className="text-gray-700">
                LinkedIn prospect discovery
              </p>
            </div>

            <div className="flex items-start gap-3">
              <div className="text-green-500 mt-1">✓</div>

              <p className="text-gray-700">
                Smart prospect filtering
              </p>
            </div>

            <div className="flex items-start gap-3">
              <div className="text-green-500 mt-1">✓</div>

              <p className="text-gray-700">
                Export-ready prospect lists
              </p>
            </div>

          </div>

        </div>
      );
    })}

  </div>

  {/* VALUE COMPARISON */}
  <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-3xl p-10 sm:p-16 mb-24">

    <div className="max-w-5xl mx-auto">

      <div className="text-center mb-14">

        <h2 className="text-4xl font-bold text-gray-900 mb-6">
          Why Teams Use Backlink Banana
        </h2>

        <p className="text-lg text-gray-600 leading-relaxed">
          Manual prospecting takes hours of repetitive searching,
          filtering, copy-pasting, and spreadsheet work.
          Backlink Banana dramatically reduces that workload.
        </p>

      </div>

      <div className="grid md:grid-cols-3 gap-8">

        <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm">

          <div className="text-4xl font-bold text-blue-600 mb-4">
            10+
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            Hours Saved Weekly
          </h3>

          <p className="text-gray-600 leading-relaxed">
            Eliminate repetitive Google searches and reduce manual prospect research.
          </p>

        </div>

        <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm">

          <div className="text-4xl font-bold text-blue-600 mb-4">
            Instant
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            SEO Metrics Included
          </h3>

          <p className="text-gray-600 leading-relaxed">
            DA, PA, and Spam Score are included with every prospect.
          </p>

        </div>

        <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-sm">

          <div className="text-4xl font-bold text-blue-600 mb-4">
            Simple
          </div>

          <h3 className="text-xl font-semibold text-gray-900 mb-3">
            Usage-Based Pricing
          </h3>

          <p className="text-gray-600 leading-relaxed">
            No monthly subscriptions or bloated enterprise contracts.
          </p>

        </div>

      </div>

    </div>

  </div>

  {/* ROI / MATH */}
  <div className="max-w-5xl mx-auto">

    <div className="text-center mb-12">

      <h2 className="text-4xl font-bold text-gray-900 mb-6">
        The Math Makes Sense
      </h2>

      <p className="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
        Prospecting manually is expensive.
        Even basic outreach research can consume hours every week.
      </p>

    </div>

    <div className="grid md:grid-cols-2 gap-8">

      <div className="rounded-3xl border border-red-100 bg-red-50 p-8">

        <h3 className="text-2xl font-bold text-red-700 mb-6">
          Manual Prospecting
        </h3>

        <div className="space-y-4 text-gray-700">

          <div className="flex justify-between border-b border-red-100 pb-3">
            <span>Finding 150 websites</span>
            <span>8-10 hours</span>
          </div>

          <div className="flex justify-between border-b border-red-100 pb-3">
            <span>Spreadsheet organization</span>
            <span>1-2 hours</span>
          </div>

          <div className="flex justify-between border-b border-red-100 pb-3">
            <span>SEO metric collection</span>
            <span>2+ hours</span>
          </div>

          <div className="flex justify-between pt-4 text-xl font-bold">
            <span>Total Time</span>
            <span>12+ hours</span>
          </div>

        </div>

      </div>

      <div className="rounded-3xl border border-green-100 bg-green-50 p-8">

        <h3 className="text-2xl font-bold text-green-700 mb-6">
          With Backlink Banana
        </h3>

        <div className="space-y-4 text-gray-700">

          <div className="flex justify-between border-b border-green-100 pb-3">
            <span>Finding 150 websites</span>
            <span>Minutes</span>
          </div>

          <div className="flex justify-between border-b border-green-100 pb-3">
            <span>SEO metrics included</span>
            <span>Instant</span>
          </div>

          <div className="flex justify-between border-b border-green-100 pb-3">
            <span>LinkedIn prospects included</span>
            <span>Instant</span>
          </div>

          <div className="flex justify-between pt-4 text-xl font-bold">
            <span>Total Cost</span>
            <span>$9</span>
          </div>

        </div>

      </div>

    </div>

  </div>

</section>


);
}
